export default __webpack_public_path__ + "static/dropshippingVp4-c8bab48f54301078e57ebae83c50ec19.png";